import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const categoryTabNavigationBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Category Tab Navigation",
  image: "https://icons.veryicon.com/png/o/miscellaneous/guodong/tabs-8.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "tabs",
      type: "list",
      required: true,
      subFields: [
        {
          name: "label",
          type: "string",
          required: true,
          localized: true,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Tab Label",
          },
        },
        {
          name: "tabContent",
          type: "uiBlocks",
          defaultValue: [],
        },
        DLT_FIELD,
        DLD_FIELD,
      ],
      defaultValue: [
        {
          label: "Tab 1",
          tabContent: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 1 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
          dlt: "",
          dld: "",
        },
        {
          label: "Tab 2",
          tabContent: [
            {
              "@type": "@builder.io/sdk:Element",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Tab 2 Content",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
          dlt: "",
          dld: "",
        },
      ],
    },
    {
      name: "initialActiveTab",
      friendlyName: "Initial Active Tab Index",
      type: "number",
      required: false,
      localized: false,
      defaultValue: 0,
    },
  ],
  defaultStyles: {
    width: "100%",
  },
};
